import { Component, OnInit, HostListener } from '@angular/core';
import { GlobalServices } from '../global.services';
import { baseUrls } from '../appConstant';

@Component({
  selector: 'app-variation-fitness',
  templateUrl: './variation-fitness.component.html',
  styleUrls: ['./variation-fitness.component.scss'],
})
export class VariationFitnessComponent implements OnInit {
  hostedUrl = baseUrls.hostedUrl;

  constructor(private globalServices: GlobalServices) {}

  @HostListener('document:click', ['$event'])
  ngOnInit(): void {
    if (this.globalServices?.isBrowser) {
      // console.log('VariationFitnessComponent');
      this.initialisingSlideConfig();
      this.globalServices?.hideHeader.next(false);
      this.globalServices?.hideFooter.next(false);
      setInterval(() => {
        // console.log("setInterval", this.textMatched, typeof(this.textMatched));
        this.textMatched += 1;
        if (this.textMatched == 7) {
          this.textMatched = 1;
        }
      }, 2500);
    }
  }
  slideConfig;
  reviewslideConfig;
  initialisingSlideConfig() {
    this.slideConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: '0px',
          },
        },
        {
          breakpoint: 1366,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
          },
        },
      ],
    };
    this.reviewslideConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,			
      infinite: true,
      dots: false,
      arrows: true,
			responsive: [
				{
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: '0px',
          },
        },
			]
    };
  }
	afterChange(e) {
    console.log('afterChange');
  }
  
  beforeChange(e) {
    console.log('beforeChange');
  }
  public accordianChange(index: number): void {
    if (this.globalServices.isBrowser) {
      let els: any = document.getElementsByClassName('accordian');
      if (els) {
        let el: any = document.getElementsByClassName('accordian')[index];
        if (el.classList.contains('active')) {
          el.classList.remove('active');
        } else {
          for (let elem of els) {
            elem.classList.remove('active');
          }
          el.classList.add('active');
        }
      }
    }
  }
  textInfo = [
    { id:1, value: " fitness" },
    { id:2, value: " yoga" },
    { id:3, value: " nutrition" },
    { id:4, value: " meditation" },
    { id:5, value: " coaching" },
    { id:6, value: " challenges" },
    { id:7, value: " rewards" }
  ];
  // textInfo = [
  //   ' fitness ',
  //   ' yoga ',
  //   ' nutrition ',
  //   ' meditation ',
  //   ' coaching ',
  //   ' challenges ',
  //   ' rewards ',
  // ];
  textMatched = 1;
  expertsArr = [
    {
      name: 'Ella Trotter',
      desc: 'Yoga, Meditation, Therapeutic Yoga - E-RYT 500h',
      img: '../../assets/images/imagesForVariationFitness/Ella.png',
    },
    {
      name: 'Chelsie Downs-Hubbarth',
      desc: 'Nutrition Coach, Certified Holistic Health Coach, Behavioural Change Specialist',
      img: '../../assets/images/imagesForVariationFitness/Chelsie.png',
    },
    {
      name: "Ken O'Connor",
      desc: 'Mobility Coach, Functional Range Conditioning Mobility Specialist',
      img: '../../assets/images/imagesForVariationFitness/Ken.png',
    },
    {
      name: 'Peggy Sealfon',
      desc: 'Certified Stress Management and Personal Development Coach',
      img: '../../assets/images/imagesForVariationFitness/Peggy.png',
    },
    {
      name: 'Michelle Coy',
      desc: 'Certified Financial Wellness Coach',
      img: '../../assets/images/imagesForVariationFitness/Michele.png',
    },
  ];

  screenshotCarousel = [
    '../../assets/images/imagesForVariationFitness/iphone-mylifewell-food-app.png',
    '../../assets/images/imagesForVariationFitness/insitu-mindvibe.png',
    '../../assets/images/imagesForVariationFitness/insitu-main.png',
    '../../assets/images/imagesForVariationFitness/insitu-groups.png',
    '../../assets/images/imagesForVariationFitness/insitu-classes-sept-2021.png',
    '../../assets/images/imagesForVariationFitness/insitu-classes-2.png',
    '../../assets/images/imagesForVariationFitness/insitu-challenges-2.png',
  ];

	getMovingCarouselImg = [
    '../../assets/images/imagesForVariationFitness/iphone-mylifewell-food-app.png',
    '../../assets/images/imagesForVariationFitness/insitu-mindvibe.png',
    '../../assets/images/imagesForVariationFitness/insitu-main.png',
    '../../assets/images/imagesForVariationFitness/insitu-groups.png',
    '../../assets/images/imagesForVariationFitness/insitu-classes-sept-2021.png',
    '../../assets/images/imagesForVariationFitness/insitu-classes-2.png',
    '../../assets/images/imagesForVariationFitness/insitu-challenges-2.png',
  ];

  reviewCarousel = [
		{
			reviewType:'user',
      device: '',
      review:
        'HR Director, traveler, dog mom to Chewie, Masterchef hopeful. Former “non-exerciser” that can do 30 pushups in a row now, down -37 lbs because of MyLifeWell.',
    },
    {
      device: 'iOS Reviews',
      review:
        '...By far the most comprehensive wellness app I have used and it’s will be my go-to going forward. So nice to be able to use ONE app for all my needs! - mj',
    },
    {
      device: 'iOS Reviews',
      review:
        "Really like it because it tracks everything from my calories to food - even how long I've meditated for (which isn't much yet...but it's growing everyday!) - neryvelazquezs",
    },
    {
      device: 'Android Reviews',
      review:
        "Crazy amount of workouts to choose from, so many different categories. I'll buy a membership when my trial is over. - Giselle Valeria",
    },
    {
      device: 'Android Reviews',
      review:
        "There's a ton of fitness apps and food trackers out there but what I like about this app is that it brings everything together into one app. No more switching between apps or copying and pasting calories from here to there. - Dania Amalea",
    },
    {
      device: 'Android Reviews',
      review:
        "I'm enjoying the meditation! I also appreciate the accessibility of the workouts to help me improve my strength and general health. - Mary Jones",
    },
  ];

  goTototalHealth() {
    console.log('Loged');
    let el: any = document.getElementById('totalHealth');

    el.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
